type FoodDrinkType = "food" | "drink" | "food_and_drink";

/**
 * Maps listing F&B configuration to a semantic food/drink type id for label args.
 */
const getFoodDrinkType = ({
  drinkOption,
  foodPackage,
}: {
  drinkOption?: string;
  foodPackage?: string;
}): FoodDrinkType | null => {
  if (!drinkOption && !foodPackage) {
    return null;
  }

  if (!drinkOption) {
    return "food";
  }

  if (!foodPackage) {
    return "drink";
  }

  const isVenueDrink =
    drinkOption === "full_bar" ||
    drinkOption === "beer_and_wine_only" ||
    drinkOption === "non_alcoholic_options_only";

  const isVenueFood =
    foodPackage === "catering_packages" ||
    foodPackage === "full_menu_a_la_carte";

  if (isVenueDrink && isVenueFood) {
    return "food_and_drink";
  }

  if (isVenueDrink) {
    return "drink";
  }

  if (isVenueFood) {
    return "food";
  }

  return "food_and_drink";
};

export type { FoodDrinkType };
export { getFoodDrinkType };
